
const recipes = [
    { 
      id: 1,
      title: "Greek salad",
      price: 12.99,
      image: "https://th.bing.com/th/id/R.0220aad136d8071340d0570e077a2025?rik=vHDWfab7IpnDqQ&pid=ImgRaw&r=0",
      description:
        "The famous greek salad of crispy lettuce, peppers, olives and our Chicago style fota cheese, garnished with crunchy garlic and rosemary croutons",
        rating: 4
    },
    {
      id: 2,
      title: "Bruchetta",
      price: 5.99,
      image: "https://i.ibb.co/317GqZv/Bruchetta.png",
      description:
        "Our Bruschetta is made from grilled bread that has been smeared with garlic and seasoned with salt and olive oil.",
        rating: 5
    },
    {
      id: 3,
      title: "Lemon Dessert",
      price: 4.78,
      image: "https://i.ibb.co/sm6MfcH/desert.jpg",
      description:
        "This comes straight from grandma's recipe book, every last ingredient has been sourced and is as authentic as can be imagined.",
        rating: 3
    },
  
  ];
  
  export default recipes;